import React, { useState } from "react";
import { connect } from "react-redux";
import { Icon, Modal, Button, Dimmer, Loader, } from "semantic-ui-react";

import ordersIcon from "../../images/icons8-edit-property-96.png";
import blackOrdersIcon from "../../images/icons8-edit-property-96black.png";
import blackHomeIcon from "../../images/icons8-home-96black.png";
import homeIcon from "../../images/icons8-home-96.png";
import translations from "../../utils/translations";
import getUrlParams from "../../utils/getUrlParams";
import { getSysCompanyInfo, authenticateClient } from '../../store/actions/access'
import clientActions from '../../store/actions/clients'

const ClientBottomBar = (props) => {
  const {
    history,
    setScreenHistory,
    authenticateClient,

    currentTranslations,
  } = props;
  const isAndroid = navigator.userAgent?.includes("Android");
  const [loading, setLoading] = useState(false);
  const [typedCode, setTypedCode] = useState("");
  const [openQrModal, setOpenQrModal] = useState(false);

  const handleBarCodeRead = async (data) => {
    setOpenQrModal(false);

    const showErrorCode = () => {
      alert("Ingresa un código válidoo.");
    };

    try {
      setLoading(true)
      const urlParams = getUrlParams(data);

      // this runs when there's a table code
      if (urlParams.tableCode) {
        if (!/^\d+[mM]+\d+$/.test(urlParams.tableCode)) {
          throw new Error('Invalid code')
        }
        const [sys_company_id, table_id] = urlParams.tableCode
          ?.toUpperCase()
          ?.split("M");
        const companyInfo = await props.getSysCompanyInfo(sys_company_id);
        const station = await props.loadTableInfo({
          sysCompanyId: sys_company_id,
          tableId: table_id,
        });
        if(!station?.id){
          throw new Error('There was an error loading the station')
        }
        props.setIsQrRead()
        if(companyInfo?.ChildCompanies?.length > 0 && companyInfo?.attention_type == 'food_center'){
          props.history.push(`/client/stalls?tableCode=${urlParams.tableCode}&qrScaned=true`)
        }else{
          props.history.push(`/client/products?tableCode=${urlParams.tableCode}&qrScaned=true`)
        }
      } else if (urlParams.companyCode) {
        const sys_company_id = urlParams.companyCode?.slice(2);

        if (!(!isNaN(sys_company_id) && sys_company_id > 0)) {
          throw new Error('')
        }

        const companyInfo = await props.getSysCompanyInfo(sys_company_id);

        props.setIsQrRead()

        if(companyInfo?.ChildCompanies?.length > 0 && companyInfo?.attention_type == 'food_center'){
          props.history.push(`/client/stalls?companyCode=${urlParams.companyCode}&&qrScaned=true`)
        }else{
          props.history.push(`/client/products?companyCode=${urlParams.companyCode}&&qrScaned=true`)
        }
      } else {
        showErrorCode();
      }
      setLoading(false)
    } catch (e) {
      setLoading(false)
      console.error(e.message);
      showErrorCode();
    }
  };

  if (loading) {
		return (
			<Dimmer active inverted className='padding-0'>
				<Loader inverted>Cargando</Loader>
			</Dimmer>
		)
	}

  return (
    <div style={styles?.barContainer}>
      <div
        style={{
          bottom: 0,
          height: '100%',
          width: "100%",
          backgroundColor: "white",
          borderTop: "1px solid #ccc",
          display: "flex",
          justifyContent: "space-around",
          alignItems: "center",
          // padding: "10px 0",
          zIndex: 1000,
        }}
      >
        {/* Botón Inicio */}
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            opacity:
              props.location?.pathname == "/client/company_qr_scanning"
                ? 1
                : 0.5,
          }}
        >
          <img
            src={
              props.location?.pathname == "/client/company_qr_scanning"
                ? homeIcon
                : blackHomeIcon
            }
            alt="home"
            onClick={() => {
              setScreenHistory(["/client/company_qr_scanning"]);
              props.history.push("/client/company_qr_scanning");
            }}
            style={{
              width: '30px',
              height: '30px',
              cursor: "pointer",
            }}
          />
          <span
            style={{
              fontSize: '13px',
              color:
                props.location?.pathname == "/client/company_qr_scanning"
                  ? "#00bcbd"
                  : "black",
              fontWeight: "700",
            }}
          >
            Inicio
          </span>
        </div>

        {/* Botón QR Central Flotante */}
        <div
          style={{
            backgroundColor: "#00c2a8",
            borderRadius: "50%",
            padding: 18,
            marginTop: -35,
            boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            cursor: "pointer",
          }}
          onClick={() => setOpenQrModal(true)}
        >
          <Icon name="qrcode" size="large" inverted />
        </div>

        {/* Botón Menú o Pedidos */}
        <div
          onClick={() => {
            authenticateClient(()=>{})
            setScreenHistory(["/client/orders"]);
            props.history.push("/client/orders");
          }}
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            opacity: props.location?.pathname == "/client/orders" ? 1 : 0.5,
          }}
        >
          <img
            src={
              props.location?.pathname == "/client/orders"
                ? ordersIcon
                : blackOrdersIcon
            }
            alt="menu"
            style={{
              width: '30px',
              height: '30px',
              cursor: "pointer",
            }}
          />
          <span
            style={{
              fontSize: '13px',
              color:
                props.location?.pathname == "/client/orders"
                  ? "#00bcbd"
                  : "black",
              fontWeight: "700",
            }}
          >
            Pedidos
          </span>
        </div>
      </div>

      <Modal
        centered={false}
        onClose={() => setOpenQrModal(false)}
        open={openQrModal}
        size="mini"
        closeIcon
      >
        <Modal.Content>
          {/* <QrReader onScan={handleBarCodeRead} /> */}

          <div style={{ marginTop: "1em", width: "100%" }}>
            <div className="inputContainer" style={{ padding: "1em" }}>
              <input
                type="text"
                className="textInput"
                placeholder={currentTranslations?.enterQrCodeManually}
                value={typedCode}
                onChange={(e) => setTypedCode(e.target.value)}
                style={{
                  width: "100%",
                  padding: "8px",
                  marginBottom: "8px",
                }}
              />

              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button
                  color="blue"
                  content={currentTranslations?.send}
                  onClick={() => {
                    const code = typedCode.toUpperCase();
                    let parsed = null;

                    if (code.includes("M")) {
                      parsed = `&tableCode=${code}`;
                    } else if (code.includes("B")) {
                      parsed = `&restroomCode=${code}`;
                    } else if (code.includes("LE")) {
                      parsed = `&waitingListCode=${code}`;
                    } else if (code.includes("SP")) {
                      parsed = `&companyCode=${code}`;
                    }

                    if (parsed) {
                      handleBarCodeRead(parsed);
                    }
                  }}
                />
              </div>
            </div>
          </div>
        </Modal.Content>
      </Modal>
    </div>
  );
};

const styles = {
  barContainer: {
    display: "flex",
    height: "8vh",
    flexDirection: "row",
    background: "white",
    alignItems: "center",
    position: "sticky",
    zIndex: 101,
    width: "100%",
    bottom: "0px",
  },
  rightSide: {
    display: "flex",
    height: "100%",
    flex: 1,
    justifyContent: "flex-end",
    alignItems: "center",
  },
  topButton: {
    fontSize: "20px",
    cursor: "pointer",
    borderRadius: "15px",
    transition: "opacity 0.2s ease",
    height: "30px",
    width: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const mapDispatchToProps = (dispatch) => ({
  setScreenHistory: (payload) => dispatch({ type: "SET_SCREEN_HISTORY", payload }),
  getSysCompanyInfo: (sys_company_id) => dispatch(getSysCompanyInfo(sys_company_id)),
  setIsQrRead: () => dispatch({ type: 'SET_IS_QR_READ' }),
  loadTableInfo: (tableInfo) => dispatch(clientActions.loadTableInfo(tableInfo)),
  authenticateClient: (functionParam) => dispatch(authenticateClient(functionParam))
});

const mapStateToProps = (state) => ({
  currentTranslations: translations[state.app.lang],
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientBottomBar);
